import { CFormInput } from '@coreui/react-pro'
import { DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { useState } from 'react'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { PATIENTS_IMPORT_FORMATS, PATIENTS_IMPORT_FORMATS_ARRAY } from 'src/consumer/constants'
import * as XLSX from 'xlsx'

export default function ImportPatientsDialog({ refreshData }) {
  const [importedPatients, setImportedPatients] = useState()
  const [importFormat, setImportFormat] = useState(PATIENTS_IMPORT_FORMATS.docon)

  function handleCsvUpload(e) {
    e.preventDefault()
    if (e.target.files) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: '' })
        var seen = {}
        var duplicateKeys = 0
        var toSet = []
        console.log(json)
        // json.forEach((currentObject, index) => {
        //   if (seen.hasOwnProperty(currentObject.key) || (seen[currentObject.key] = false)) {
        //     ++duplicateKeys
        //     return
        //   }
        //   toSet.push(currentObject)
        // })
        setImportedPatients(toSet)
      }
      reader.readAsArrayBuffer(e.target.files[0])
    }
  }

  return (
    <>
      <DialogTitle>Import Patients From CSV file</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomSelect
              value={importFormat}
              options={PATIENTS_IMPORT_FORMATS_ARRAY}
              onChangeEvent={(e) => setImportFormat(e.target.value)}
              getOptionValue={(optn) => optn?.id}
              getOptionLabel={(optn) => optn?.title}
              selectType={selectTypes.string}
              label="Data Format"
              subLabel="Select the format of the data you are uploading."
            />
          </Grid>
          <Grid item xs={12}>
            <CFormInput type="file" accept=".csv" onChange={handleCsvUpload} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions></DialogActions>
    </>
  )
}
